import { useState } from 'react';
import './Quote.css';

const Quote = () => {
  const [formData, setFormData] = useState({
    businessType: '',
    companyName: '',
    address: '',
    email: '',
    province: '',
    postalCode: '',
    faxNumber: '',
    phoneNumber: '',
    comments: '',
    hasRollFormingLines: '',
    // Equipment specifications
    equipmentCompany: '',
    lineDirection: '',
    make: '',
    model: '',
    serialNumber: '',
    shaftDiameter: '',
    shaftWithKey: false,
    numberOfPasses: '',
    rollSpace: '',
    verticalCentresFrom: '',
    verticalCentresTo: '',
    horizontalCentres: '',
    topDrive: '',
    noDisconnectForTopDrive: false,
    motorHorsepower: '',
    acVariable: false,
    dcVariable: false,
    otherVariable: ''
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value, type } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? (e.target as HTMLInputElement).checked : value
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle form submission
    console.log('Form submitted:', formData);
  };

  return (
    <div className="quote-page">
      <div className="container">
        <h1>Request a Quote</h1>
        <p className="page-intro">
          Fill out the form below and we'll get back to you with a customized quote
        </p>

        <form onSubmit={handleSubmit} className="quote-form">
          <section className="form-section">
            <h2>Contact Information</h2>
            <div className="form-grid">
              <div className="form-group">
                <label htmlFor="businessType">Type of Business</label>
                <input
                  type="text"
                  id="businessType"
                  name="businessType"
                  value={formData.businessType}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label htmlFor="companyName">Company Name *</label>
                <input
                  type="text"
                  id="companyName"
                  name="companyName"
                  value={formData.companyName}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group full-width">
                <label htmlFor="address">Address</label>
                <input
                  type="text"
                  id="address"
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label htmlFor="email">Email *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="phoneNumber">Phone Number *</label>
                <input
                  type="tel"
                  id="phoneNumber"
                  name="phoneNumber"
                  value={formData.phoneNumber}
                  onChange={handleChange}
                  placeholder="(include area code)"
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="province">Province/State</label>
                <input
                  type="text"
                  id="province"
                  name="province"
                  value={formData.province}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label htmlFor="postalCode">Postal Code</label>
                <input
                  type="text"
                  id="postalCode"
                  name="postalCode"
                  value={formData.postalCode}
                  onChange={handleChange}
                />
              </div>
            </div>
          </section>

          <section className="form-section">
            <h2>Questions/Comments</h2>
            <div className="form-group">
              <textarea
                name="comments"
                value={formData.comments}
                onChange={handleChange}
                rows={6}
                placeholder="Please describe your requirements..."
              />
            </div>
            <div className="form-group">
              <label htmlFor="hasRollFormingLines">Do you have any roll forming lines?</label>
              <textarea
                id="hasRollFormingLines"
                name="hasRollFormingLines"
                value={formData.hasRollFormingLines}
                onChange={handleChange}
                rows={3}
              />
            </div>
          </section>

          <section className="form-section">
            <h2>Equipment Specifications (if applicable)</h2>
            <div className="form-grid">
              <div className="form-group">
                <label htmlFor="equipmentCompany">Company</label>
                <input
                  type="text"
                  id="equipmentCompany"
                  name="equipmentCompany"
                  value={formData.equipmentCompany}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label htmlFor="make">Make</label>
                <input
                  type="text"
                  id="make"
                  name="make"
                  value={formData.make}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label htmlFor="model">Model</label>
                <input
                  type="text"
                  id="model"
                  name="model"
                  value={formData.model}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label htmlFor="serialNumber">Serial Number</label>
                <input
                  type="text"
                  id="serialNumber"
                  name="serialNumber"
                  value={formData.serialNumber}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label htmlFor="shaftDiameter">Shaft Diameter</label>
                <div className="input-with-checkbox">
                  <input
                    type="text"
                    id="shaftDiameter"
                    name="shaftDiameter"
                    value={formData.shaftDiameter}
                    onChange={handleChange}
                  />
                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      name="shaftWithKey"
                      checked={formData.shaftWithKey}
                      onChange={handleChange}
                    />
                    with key
                  </label>
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="numberOfPasses">Number of Passes</label>
                <input
                  type="text"
                  id="numberOfPasses"
                  name="numberOfPasses"
                  value={formData.numberOfPasses}
                  onChange={handleChange}
                />
              </div>
            </div>
          </section>

          <div className="form-actions">
            <button type="submit" className="submit-button">Submit Request</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Quote;